var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2C8.78403 2 9.01429 2.23025 9.01429 2.51429V7.48571H13.9857C14.2697 7.48571 14.5 7.71597 14.5 8C14.5 8.28403 14.2697 8.51429 13.9857 8.51429H9.01429V13.4857C9.01429 13.7697 8.78403 14 8.5 14C8.21597 14 7.98571 13.7697 7.98571 13.4857V8.51429H3.01429C2.73025 8.51429 2.5 8.28403 2.5 8C2.5 7.71597 2.73025 7.48571 3.01429 7.48571H7.98571V2.51429C7.98571 2.23025 8.21597 2 8.5 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlus);
export default __webpack_public_path__ + "static/media/white-plus.a7e113fbcf4e7facf628e6be9c730ffb.svg";
export { ForwardRef as ReactComponent };